import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPeopleGroup, faBell, faRobot, faSave, faPlus, faArrowAltCircleRight, faArrowAltCircleLeft, faHexagonNodes, faPlay, faChevronCircleLeft, faLandmark, faWindowRestore } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faCircleDown } from '@fortawesome/free-regular-svg-icons';
import CommonHexagonBadge from '../components/common/CommonHexagonBadge';
import toastService from '../services/toastService';

import {
  formatString,
  Input,
  PageContainer,
  SectionTitle,
  SubSectionTitle,
  ButtonSuccess,
  Button,
  Select,
  StatusBadge,
  FormGroup,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  FormRow,
  Label,
  formatDate,
  InfoBox,
  FlexLayout,
  Flex1ThirdLayout,
  Flex2ThirdLayout,
  FormRowFull,
  StepIndicator,
  Step,
  Toggle,
  ToggleInput,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  Divider,
  Card,
  CardTitle,
  fadeIn,
  Modal,
  StepCircle,
  StepLabel,
  Footer,
  ModalContent,
  useGoBack,
  SearchInput,
  Textarea
} from '../styles/PageStyles';
import { get } from '../utils/apiUtils';
import { createKnowledgeBase, getKnowledgeBases, updateKnowledgeBase } from '../services/knowledgeBaseService_v2';
import { getAllConnectorsByFilter } from '../services/connectorService';
import { getDataSources, updateDataSource, createDataSource } from '../services/dataSourceService';
import { useDropzone } from 'react-dropzone';
import { listFiles, uploadFile } from '../services/fileUploadService';
import { fetchCountByFilter, getAllEntitiesByFilter } from '../services/entityService';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import Pagination from '../components/common/Pagination';
import { deleteDataSource, deleteFilesfromDataSource, deleteFilesToKnowledgebase, fetchKBStoredFiles, ingestFilesToKnowledgebase } from '../services/kbQueryService';
import GenericModal from '../components/common/GenericModal';
import { useToast } from '../components/common/ToastProvider';

const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 4px;
  position: relative;
`;

const ToggleOption = styled.button`
  padding: 6px 14px;
  border: none;
  background: ${props => props.$active ? '#ffffff' : 'transparent'};
  color: ${props => props.$active ? (props.$isLinked ? '#dc2626' : '#3b82f6') : '#6b7280'};
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 1;
  min-width: 80px;
  box-shadow: ${props => props.$active ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    color: ${props => props.$active ? (props.$isLinked ? '#dc2626' : '#3b82f6') : '#374151'};
  }
`;

const FileNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
`;


const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280; /* Neutral gray */
  transition: color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: #ef4444; /* Turns red on hover */
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
  }
`;


const ToggleSwitch = ({ isLinked, onChange }) => {
  return (
    <ToggleContainer>
      <ToggleOption
        $active={isLinked}
        $isLinked={true}
        onClick={() => onChange(true)}
      >
        Linked
      </ToggleOption>
      <ToggleOption
        $active={!isLinked}
        $isLinked={false}
        onClick={() => onChange(false)}
      >
        Unlinked
      </ToggleOption>
    </ToggleContainer>
  );
};



const KnowledgebaseDetails_V2 = () => {
  const { knowledgebaseId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [knowledgeBaseDetail, setKnowledgebaseDetail] = useState();
  const [connector, setConnector] = useState();
  const [dataSource, setDataSource] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [activeTab, setActiveTab] = useState('basicDetails');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [maxSize, setMaxSize] = useState(10 * 1024 * 1024); // 10 MB
  const [fileTypes, setFileTypes] = useState(['.pdf', '.png', '.jpg', '.xlsx', '.txt', '.json', '.md']);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isEntityDrawerOpen, setIsEntityDrawerOpen] = useState(false);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [selectedDataSourceIndex, setSelectedDataSourceIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentSetupStep, setCurrentSetupStep] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [newValue, setNewValue] = useState(null);
  const [newKey, setNewKey] = useState(null);
  const [config, setConfig] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entitySearchTerm, setEntitySearchTerm] = useState('');
  const [kbFiles, setKbFiles] = useState({});
  const [kbOverRideModalOpen, setKbOverRideModalOpen] = useState(false);
  const [isOverRideKb, setIsOverRideKb] = useState(false)
  const {showToast} = useToast();

  
  const itemsPerPage = 10;


  // For COnnector corresponding to DS
  useEffect(() => {
    const fetchConnectors = async () => {
      try {
        let filter = {}
        const response = await getAllConnectorsByFilter(filter, {});
        setConnector(response || []);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchConnectors();
  }, [user]);


  // For KNowledgeBase Current
  useEffect(() => {
    const fetchKnowledgebaseByCode = async () => {
      try {
        const parsedKnowledgebaseId = (knowledgebaseId); // Parse entityId as a number

        let filter = {
          "code": parsedKnowledgebaseId
        }
        const response = await getKnowledgeBases(filter, {});
        setKnowledgebaseDetail({
          ...response[0],
          pii_flag: response[0]?.pii_flag ?? false,
          running_version: response[0]?.running_version || 'v1',
        });

      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    if (knowledgebaseId !== 'new') {
      fetchKnowledgebaseByCode();
    } else {
      setKnowledgebaseDetail({
        code: "KB-" + new Date().getTime(),
        name: "",
        description: "",
        company_cd: user?.companyCd,
        pii_flag: false,
        data_source: [],
        entities: [],
        running_version: 'v1',
      });
    }

  }, [knowledgebaseId, user]);

  const fetchFiles = useCallback(async () => {
    try {
      if (knowledgeBaseDetail?.code) {

        const response = await listFiles(knowledgeBaseDetail.code, selectedDataSource.code);
        setUploadedFiles(response || []);
      }
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  }, [knowledgeBaseDetail?.code, selectedDataSource?.code]);

  useEffect(() => {
    if (knowledgeBaseDetail && selectedDataSource) {
      fetchFiles();
    }
  }, [knowledgeBaseDetail?.code, selectedDataSource, user]); // Trigger this effect when knowledgeBaseDetail changes


  // For Datasource
  const fetchDataSourcesWithConnectors = async () => {
    try {
      if (Array.isArray(knowledgeBaseDetail?.data_source) && knowledgeBaseDetail.data_source.length > 0) {
        // Fetch data sources
        const dataSourceResponses = await Promise.all(
          knowledgeBaseDetail.data_source.map((dataSourceName) => {
            const filter = { code: dataSourceName };
            return getDataSources(filter, {});
          })
        );

        // Extract the first record from each data source response
        const fetchedDataSources = dataSourceResponses.map((response) => response[0]).filter(Boolean);

        // Fetch connectors for each data source and add connector details
        const updatedDataSources = await Promise.all(
          fetchedDataSources.map(async (ds) => {
            const connectorResponse = connector.filter((conn) => conn.code === ds.connector);
            const connectorDetails = connectorResponse[0]; // Get the first connector
            return { ...ds, connectorDetails }; // Add connector details to the data source
          })
        );

        // Update the dataSource state with the enriched data sources
        setDataSource(updatedDataSources);
      }
    } catch (error) {
      console.error('Error fetching data sources or connectors:', error);
    }
  };

  useEffect(() => {
    fetchDataSourcesWithConnectors();
  }, [knowledgeBaseDetail?.data_source, connector]);

  useEffect(() => {
    
    fetchEntityCount();

    getDataConfig().then(data => {
      setConfig(data)
      setTotalItems(data.totalCount)
    });
  },[])

  useEffect(() => {
  if (!config) return;
  
  fetchPageData(currentPage, config)
    .then(setEntityList)
    .finally(() => {});
}, [currentPage, config]);


  const getDataConfig = async () => {
  const [count1, count2] = await Promise.all([
    fetchEntityCount(),
    fetchDocumentCount()
  ]);
  
  return {
    count1,
    count2,
    totalCount: count1 + count2,
    totalPages: Math.ceil((count1 + count2) / itemsPerPage)
  };
};

const fetchPageData = async (currentPage, config) => {
  const skip = (currentPage - 1) * itemsPerPage;

  if (skip < config.count1) {
    const limit = Math.min(itemsPerPage, config.count1 - skip);
    const data1 = await fetchEntites({ skip, limit, type: "entity" });
    
    if (data1.length < itemsPerPage && skip + data1.length === config.count1) {
      const remainingNeeded = itemsPerPage - data1.length;
      const data2 = await fetchEntites({ skip: 0, limit: remainingNeeded, type: "document" });
      return [...data1, ...data2];
    }
    
    return data1;
  } 
  else {
    const adjustedSkip = skip - config.count1;
    const data2 = await fetchEntites({ skip: adjustedSkip, limit: itemsPerPage , type: "document"});
    return data2;
  }
};
  const filteredEntities = entityList.filter((en, index) => en.name.toLowerCase().includes(entitySearchTerm.toLowerCase()));

  const openDrawer = (ds, index) => {
    if (!ds.data) {
      ds.data = {};
    }
    setSelectedDataSource(ds);
    setSelectedDataSourceIndex(index);
    setIsDrawerOpen(true);
  };


   const fetchEntityCount = async () => {
      try {
        const table_name = "entity"
        const query = {type : "entity"}
        const count = await fetchCountByFilter(table_name, query);
        return count;
      } catch (error) {
        console.log("Error while fetching entity count", error);
      }
    }
  const fetchDocumentCount = async () => {
      try {
        const table_name = "entity"
        const query = {type : "document"}
        const count = await fetchCountByFilter(table_name, query);
        return count;
      } catch (error) {
        console.log("Error while fetching entity count", error);
      }
    }

    const fetchEntites = async ({skip, limit, type}) => {
      try {
        const queryParams = `skip=${skip}&limit=${limit}`;
        const response = await getAllEntitiesByFilter({type: type}, {}, queryParams);
        return response;
      } catch (error) {
        console.error('Error fetching files:', error);
      }
    };
    

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedDataSource(null);
    setSelectedDataSourceIndex(null);
  };

  const saveDsChanges = async (updatedDataSource, index) => {
    let dataSourceCopy = JSON.parse(JSON.stringify(updatedDataSource));
    delete dataSourceCopy.connectorDetails;
    dataSourceCopy.validated = false;
    try {
      const updateResponse = await updateDataSource(dataSourceCopy);
      if (updateResponse) {
        setDataSource((prevDataSource) => {
          const updatedDataSourceList = [...prevDataSource];
          updatedDataSourceList[index] = { ...updatedDataSource, updated_at: new Date().toLocaleString(), validated: false };
          return updatedDataSourceList;
        });
      }
    } catch (error) {

    }
    closeDrawer();
  };

  const verifyDs = async (updatedDataSource, index) => {
    let dataSourceCopy = JSON.parse(JSON.stringify(updatedDataSource));
    delete dataSourceCopy.connectorDetails;
    dataSourceCopy.validated = true;
    try {
      const updateResponse = await updateDataSource(dataSourceCopy);
      if (updateResponse) {
        setDataSource((prevDataSource) => {
          const updatedDataSourceList = [...prevDataSource];
          updatedDataSourceList[index] = { ...updatedDataSource, updated_at: new Date().toLocaleString(), validated: true };
          return updatedDataSourceList;
        });
      }
    } catch (error) {

    }
    closeDrawer();
  };

  const onDrop = async (acceptedFiles, rejectedFiles) => {
    // Handle rejected files
    if (rejectedFiles.length > 0) {
      rejectedFiles.forEach((file) => {
        if (file.errors.some((err) => err.code === 'file-too-large')) {
          toastService.error(`File "${file.file.name}" exceeds the maximum size of ${maxSize / (1024 * 1024)} MB.`);
        }
        if (file.errors.some((err) => err.code === 'file-invalid-type')) {
          toastService.error(`File "${file.file.name}" is not an allowed type. Allowed types: ${fileTypes.join(', ')}`);
        }
      });
    }

    // Upload each file and update the uploadedFiles state
    // const uploadedFileDetails = [];
    const failedFiles = [];

    for (const file of acceptedFiles) {
      try {
        const fileName = await handleUpload(file);
        if (fileName?.data?.url) {
          // Update data source with URL
          setSelectedDataSource(prev => ({
            ...prev,
            data: {
              ...prev.data,
              url: fileName.data.url
            }
          }));

          // uploadedFileDetails.push({
          //   "file_name": file.name,
          //   "updated_at": new Date().toLocaleString(),
          //   "url": fileName.data.url
          // });
          const res = await fetchKBStoredFiles(file.name, knowledgeBaseDetail?.code);
          // const res = await fetchKBStoredFiles(fi);

          setKbFiles((prev) => ({
            ...prev,
            [fileName?.data?.url] : res?.map((fileEl) => fileEl.stored_path) || []
          }))
          console.log("files documents:", res)
          if (res.length > 0) {
            setKbOverRideModalOpen(true);
          }
        } else {
          failedFiles.push(file.name);
        }
      } catch (error) {
        console.error(`Error uploading ${file.name}:`, error);
        failedFiles.push(file.name);
      }
    }

    // Update the uploadedFiles state once
    // if (uploadedFileDetails.length > 0) {
    //   setUploadedFiles((prevFiles) => [...prevFiles, ...uploadedFileDetails]);
    //   toastService.success(`Successfully uploaded ${uploadedFileDetails.length} file(s)`);
    // }

    if (failedFiles.length > 0) {
      toastService.error(`Failed to upload: ${failedFiles.join(', ')}`);
    }
  };


  const handleUpload = async (file) => {
    if (file) {

      try {
        const response = await uploadFile(file, knowledgeBaseDetail.code, selectedDataSource?.code, new Date().getTime());
        return response;

      } catch (error) {
        console.error('Error uploading file:', error);
        toastService.error(`Failed to upload ${file.name}: ${error.message}`);
        return null;
      }
    }
    return null;
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxSize,
    accept: {
      'application/pdf': ['.pdf'],
      'image/png': ['.png'],
      'image/jpeg': ['.jpg'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'application/octet-stream': ['.xlsx'],
      'text/plain': ['.txt', '.md'],
      'application/json': ['.json']
    },
  });

  // ENTITY DRAWER DETAILS
  const openEntityDrawer = (entity, index) => {
    setSelectedEntity(entity);
    setIsEntityDrawerOpen(true);
  };

  const closeEntityDrawer = () => {
    setIsEntityDrawerOpen(false);
    setSelectedEntity(null);
  };
  const linkUnlinkEntity = async (entity) => {
    if (!knowledgeBaseDetail?.entities) {
      knowledgeBaseDetail.entities = [];

    }
    const existingEntity = knowledgeBaseDetail?.entities.find((existingEntity) => existingEntity === entity?.code);
    if (existingEntity) {
      knowledgeBaseDetail.entities = knowledgeBaseDetail?.entities.filter((existingEntity) => existingEntity !== entity?.code);
      setKnowledgebaseDetail({ ...knowledgeBaseDetail });
    } else {
      knowledgeBaseDetail.entities.push(entity?.code);
      setKnowledgebaseDetail({ ...knowledgeBaseDetail });
    }
  }

  const checkIfPresent = (code) => {
    if (knowledgeBaseDetail?.entities && knowledgeBaseDetail?.entities.length > 0) {
      const entity = knowledgeBaseDetail?.entities.indexOf(code);
      return (entity > -1) ? true : false;
    }
    return false
  }
  const filteredAttributes = (selectedEntity?.attributes || []).filter((attrib) => {
    return attrib?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
    // return user
  });

  const getAttribType = (type) => {
    switch (type) {
      case 'STR':
        return 'String';
      case 'INT':
        return 'Integer';
      case 'FLOAT':
        return 'Float';
      case 'DATE':
        return 'Date';
      case 'ENTITY':
        return 'Entity';
      default:
        return type;
    }
  }
  // Add New Data Source From Connector Modal
  const openModal = () => {
    const dataSource = {
      "code": "DS-" + new Date().getTime(),
      "name": "",
      "status": "INACTIVE",
      "description": "",
      "connector": "",
    }
    setSelectedDataSource(dataSource);
    setShowModal(true);
  }

  const closeModal = () => {
    setShowModal(false);
  }

  const addDataSource = async (conn) => {
    selectedDataSource.connector = conn.code;
    if (selectedDataSource.name == '') {
      toastService.error("Please enter the name of the data source.");
      return;
    }
    try {
      const response = await createDataSource(selectedDataSource);
      let resp = JSON.parse(JSON.stringify(response));
      resp.connectorDetails = conn;
      dataSource.push(resp);
      setDataSource([...dataSource]);
      knowledgeBaseDetail.data_source.push(resp.code);
      setKnowledgebaseDetail({ ...knowledgeBaseDetail });
      setSelectedDataSource(null);
    } catch (error) {
      console.error('Error creating data source:', error);

    }
    setShowModal(false);
  }



  // REVIEW and Save Knowledgebase
  const renderEntity = (kbEntityList) => {
    if (kbEntityList && kbEntityList.length > 0) {
      return kbEntityList.map((entity, index) => (
        <span key={index}>
          {entity}
          {index < kbEntityList.length - 1 ? ', ' : ''}
        </span>
      ));
    }
    return "-";
  }
  const getNonConnectorProperties = () => {
    const connectorProperties = selectedDataSource.connectorDetails?.properties || [];
    return Object.keys(selectedDataSource.data || {}).filter(
      (key) => !connectorProperties.includes(key)
    );
  };

  const addCustomProperty = (key, value) => {
    setSelectedDataSource((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [key]: value,
      },
    }));
  };
  const removeCustomProperty = (key) => {
    const updatedData = { ...selectedDataSource.data };
    delete updatedData[key];
    setSelectedDataSource((prev) => ({
      ...prev,
      data: updatedData,
    }));
  };
  const saveKnowledgebase = async () => {
    try {
      if (knowledgeBaseDetail.id) {

        const updatedKb = await updateKnowledgeBase(knowledgeBaseDetail);
        await ingestFile(updatedKb?.code);
        toastService.success("Knowledgebase updated successfully.");
      } else {
        const createdKb = await createKnowledgeBase(knowledgeBaseDetail);
        await ingestFile(createdKb?.code);
        toastService.success("Knowledgebase created successfully.");

      }
      navigate('/knowledge-base');
    } catch (error) {

    }
  }

  const handleDeleteKBFileInggestion = async (doc) => {
    try {
      const payload = {
        [doc.url] : []
      }
      console.log("doc", doc)
      // const respDelDS = await deleteDataSource(doc.file_type)
      const respOfKB = await deleteFilesToKnowledgebase(knowledgeBaseDetail?.code ,payload);
      const respOfFile = await deleteFilesfromDataSource('files', doc.id);
      console.log("Resp of the deltting the kb files",respOfKB, respOfFile)
      if(respOfKB?.status == "accepted") {
        setIsDrawerOpen(false);
        fetchFiles();
        showToast({
          type:"success",
          message: "Data source file inggestion removed successfully."
        })

      }
    } catch (error) {
      console.log("Error deleting the KB inggestion.")
    }
  }

  const ingestFile = async (kbCode) => {
    try {
      const fileList = {};
      dataSource.forEach((ds) => {
        if(ds.connector == 'Document' && ds?.data?.url) {
          fileList[ds.data.url] = [];
        }
      });
      const resp = await ingestFilesToKnowledgebase(kbCode, kbFiles, isOverRideKb);
    } catch (error) {
      console.log("Error inggesting files from kb");
    }
  }

   const handleToggle = (id, value) => {
    setEntityList(filteredEntities.map(entity => 
      entity.id === id ? { ...entity, isLinked: value } : entity
    ));
  };
  const steps = ['Basic Info', 'Data Sources', 'Entities', 'Validate', 'Review'];
  const goBack = useGoBack();
  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        {/* <SectionTitle>
          <Button onClick={goBack} secondary ><FontAwesomeIcon icon={faChevronCircleLeft} /></Button>
          {knowledgeBaseDetail?.name ? (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              {knowledgeBaseDetail?.name}
            </span>
          ) : (
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
              Add Knowledgebase
            </span>
          )}
        </SectionTitle> */}
        <PageHeaderWithInfo
          icon={faLandmark}
          goBack={true}
          title={knowledgeBaseDetail?.name ? knowledgeBaseDetail?.name : "Add Knowledgebase"}
          description="Manage the knowledge sources that power your AI agents. Upload documents, connect to external data sources, and organize information to ensure your agents have access to accurate and up-to-date information."
        >
        </PageHeaderWithInfo>

        <Divider />
        {/* Progress Indicator */}
        <StepIndicator>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepCircle
                active={currentSetupStep === index + 1}
                completed={currentSetupStep > index + 1}
                onClick={() => setCurrentSetupStep(index + 1)}
              >
                {/* {currentSetupStep > index + 1 ? 'âœ“' : index + 1} */}
                {currentSetupStep > index + 1 ? "✔" : index + 1}
              </StepCircle>
              <StepLabel active={currentSetupStep === index + 1}>{step}</StepLabel>
            </Step>
          ))}
        </StepIndicator>

        {/* Step 1: Basic Info */}
        {currentSetupStep === 1 && (
          <>
            <InfoBox>
              Start by defining the basic information about your Knowledgebase. This includes the name, description, PII Flag and any other relevant details that will help you identify and manage your Knowledgebase effectively.
            </InfoBox>
            <Divider />
            <FormRow>
              <FormGroup>
                <Label>Name</Label>
                <Input type="text" 
                       value={knowledgeBaseDetail?.name || ''} 
                       onChange={(e) => setKnowledgebaseDetail({ ...knowledgeBaseDetail, name: e.target.value })}
                       style={{borderColor:'#99c1ff'}} />
              </FormGroup>
              <FormGroup>
                <Label>Mask Personal Data</Label>
                <Toggle>
                  <ToggleInput
                    type="checkbox"
                    checked={knowledgeBaseDetail?.pii_flag === true}
                    onChange={(e) => {
                      setKnowledgebaseDetail({
                        ...knowledgeBaseDetail,
                        pii_flag: e.target.checked, // Update pii_flag instead of status
                      });
                    }}
                  />
                </Toggle>
              </FormGroup>

            </FormRow>
            <FormRowFull>
              <FormGroup>
                <Label>Description</Label>
                <Textarea type="text" value={knowledgeBaseDetail?.description || ''} onChange={(e) => setKnowledgebaseDetail({ ...knowledgeBaseDetail, description: e.target.value })} />
              </FormGroup>

            </FormRowFull>

            <FormRowFull>
              <FormGroup>
                <Label>Running Version</Label>
                <Select
                  value={knowledgeBaseDetail?.running_version || 'v1'}
                  onChange={(e) =>
                    setKnowledgebaseDetail({
                      ...knowledgeBaseDetail,
                      running_version: e.target.value,
                    })
                  }
                >
                  <option value="v1">v1</option>
                  <option value="v2">v2</option>
                </Select>
              </FormGroup>
            </FormRowFull>

          </>
        )}

        {/* Step 2: Sources */}
        {currentSetupStep === 2 && (
          <>
            <InfoBox>
              Register Your Data Sources: Connect your data sources to the Knowledgebase. This step allows you to link various data sources, such as databases, APIs, or files, that will be used to populate the Knowledgebase with relevant information.
            </InfoBox>
            <Divider />
            <FormRow>
              <FormGroup>
                <Label>&nbsp;</Label>
                <ButtonSuccess onClick={() => openModal()
                }>
                  <FontAwesomeIcon icon={faPlus} /> Data Source</ButtonSuccess>
              </FormGroup>
            </FormRow>
            {knowledgeBaseDetail?.data_source && (
              <>
                {dataSource.map((ds, index) => (
                  <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} className={ds.status === "INACTIVE" ? "INACTIVE" : ""}>
                    <CardTitle>
                      <CommonHexagonBadge
                        stroke="stroke-brand-clarity"
                        fill="fill-brand-light"
                        size="size-[50px]"
                        iconImage={`/assets/images/connectors/${ds.connector}.png`}
                        style={{ cursor: 'pointer' }}
                      />
                      <div style={{ cursor: 'pointer' }}>
                        <h5>Data Source: {ds.name}</h5>
                        <p>{ds.connectorDetails?.description || ''}</p>
                      </div>
                      <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => openDrawer(ds, index)}><FontAwesomeIcon icon={faGear} /> Manage</Button>
                      </div>
                    </CardTitle>
                  </Card>
                ))}
              </>
            )}
          </>
        )}

        {/* Step 3: Entities */}
        {currentSetupStep === 3 && (
          <>
            <InfoBox>
              Map Entities to Data Sources: In this step, you will link the entities that you want to associate with your Knowledgebase. This allows you to define the relationships between different data sources and the entities they represent.
            </InfoBox>
            <Divider />
  <PageHeaderWithInfo
          icon={faWindowRestore}
          title="Entity"
          description="The Entity page is designed to manage the knowledge sources and documents that power AI agents."
        >
               <div style={{ display: 'flex', gap: "1rem" }}>
            <SearchInput
              type="text"
              placeholder="Search Entities..."
              value={entitySearchTerm}
              onChange={(e) => setEntitySearchTerm(e.target.value)}
            />
          </div>
          </PageHeaderWithInfo>

            {filteredEntities.map((entity, index) => (
              <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} >
                <CardTitle>
                  <CommonHexagonBadge
                    stroke="stroke-brand-clarity"
                    fill="fill-brand-light"
                    size="size-[50px]"
                    badge={faHexagonNodes}
                    style={{ cursor: 'pointer' }}
                  />
                  <div style={{ cursor: 'pointer' }}>
                    <h5>{entity.name}</h5>
                    <p>{entity.description || ''}</p>
                  </div>
                  <div style={{ 
  marginLeft: 'auto', 
  marginRight: '50px', 
  display: 'flex', 
  gap: '14px', 
  justifyContent:'space-between',
  alignItems: 'center' 
}}>

   <ToggleSwitch
              isLinked={checkIfPresent(entity?.code)}
              onChange={() => linkUnlinkEntity(entity)}
            />
  <Button 
    style={{ 
      padding: '0.3rem 0.6rem', 
      fontSize: '0.8rem',
      minWidth: '90px' // Fixed width for Manage button
    }} 
    onClick={() => openEntityDrawer(entity, index)}
  >
    <FontAwesomeIcon icon={faGear} /> Manage
  </Button>
</div>
                </CardTitle>
              </Card>
            ))}
              <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalCount={totalItems}
                        setCurrentPage={setCurrentPage}
                        setTotalPages={setTotalPages}
                    />
          </>
        )}

        {/* Step 4: Validate */}
        {currentSetupStep === 4 && (
          <>
            <InfoBox>
              Validate your connections and ensure that the data sources are correctly linked to the Knowledgebase. This step allows you to verify that the data sources are accessible and that the entities are properly associated with the Knowledgebase.
            </InfoBox>
            <Divider />
            {knowledgeBaseDetail?.data_source && (
              <>
                {dataSource.map((ds, index) => (
                  <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} className={ds.status === "INACTIVE" ? "INACTIVE" : ""}>
                    <CardTitle>
                      <CommonHexagonBadge
                        stroke="stroke-brand-clarity"
                        fill="fill-brand-light"
                        size="size-[50px]"
                        iconImage={`/assets/images/connectors/${ds.connector}.png`}
                        style={{ cursor: 'pointer' }}
                      />
                      <div style={{ cursor: 'pointer' }}>
                        <h5>Data Source: {ds.name}</h5>
                        <p>{ds.connectorDetails?.description || ''}</p>
                      </div>
                      <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        {ds.validated ? <StatusBadge status={'active'}>Validated</StatusBadge> : <StatusBadge status={'inactive'}>Not Validated</StatusBadge>}

                        <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => verifyDs(ds, index)}><FontAwesomeIcon icon={faPlay} /> Test</Button>
                      </div>
                    </CardTitle>
                  </Card>
                ))}
              </>
            )}
          </>
        )}

        {/* Step 5: Review */}
        {currentSetupStep === 5 && (
          <>
            <InfoBox>
              Review your knowledgebase configuration and ensure that all the data sources, entities, and connections are set up correctly.
            </InfoBox>
            <Divider />
            {knowledgeBaseDetail && (
              <>
                <Table>
                  <tbody>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Name</td>
                      <td width={'30px'}>:</td>
                      <td>{knowledgeBaseDetail?.name}</td>
                    </TableRow>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Desciption</td>
                      <td width={'30px'}>:</td>
                      <td>{knowledgeBaseDetail?.description}</td>
                    </TableRow>

                    <TableRow height={'30px'}>
                      <td width={'200px'}>Remove PII Data</td>
                      <td width={'30px'}>:</td>
                      <td>{knowledgeBaseDetail?.pii_flag}</td>
                    </TableRow>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Data Sources</td>
                      <td width={'30px'}>:</td>
                      <td>
                        {dataSource.map((ds, index) => (
                          <TableRow height={'30px'} key={index}>
                            <td width={'200px'}>
                              {ds?.name}
                            </td>
                            <td>
                              {ds.validated ? <StatusBadge status={'active'}>Validated</StatusBadge> : <StatusBadge status={'inactive'}>Not Validated</StatusBadge>}
                            </td>
                            <td>
                              {ds.status == 'ACTIVE' ? <StatusBadge status={'active'}>Active</StatusBadge> : <StatusBadge status={'inactive'}>In-Active</StatusBadge>}
                            </td>
                          </TableRow>
                        ))}
                      </td>
                    </TableRow>
                    <TableRow height={'30px'}>
                      <td width={'200px'}>Entities</td>
                      <td width={'30px'}>:</td>
                      <td>
                        {renderEntity(knowledgeBaseDetail?.entities)}
                      </td>
                    </TableRow>

                  </tbody>
                </Table>

              </>
            )}
          </>
        )}


        <Footer>
          {currentSetupStep > 1 && (
            <Button
              onClick={() => setCurrentSetupStep(currentSetupStep - 1)}
              style={{ background: 'transparent', color: 'var(--primary)', border: '1px solid var(--primary)' }}
            >
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />  Previous
            </Button>
          )}

          <div style={{ flex: '1' }}></div>

          {currentSetupStep < 5 ? (
            <Button
              onClick={() => setCurrentSetupStep(currentSetupStep + 1)}
              style={{ minWidth: '100px' }}
            >
              Next <FontAwesomeIcon icon={faArrowAltCircleRight} />
            </Button>
          ) : (
            <Button primary onClick={() => saveKnowledgebase()}>
              <FontAwesomeIcon icon={faSave} /> Save Knowledgebase</Button>
          )}
        </Footer>




      </motion.div>

      {/* Custom Drawer */}
      {isDrawerOpen && (
        <div className="custom-drawer">
          <div className="drawer-content">
            <SubSectionTitle>Data Source Details</SubSectionTitle>
            <Divider />
            {selectedDataSource && (
              <>
                <div style={{ paddingBottom: '50px' }}>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input
                      type="text"
                      value={selectedDataSource.name || ''}
                      onChange={(e) =>
                        setSelectedDataSource({
                          ...selectedDataSource,
                          name: e.target.value,
                        })
                      }
                    />
                  </FormGroup>



                  {selectedDataSource.connectorDetails?.code == "Document" ? (
                    <>
                      {/* Drag-and-Drop Area */}
                      <div
                        {...getRootProps()}
                        style={{
                          border: '2px dashed #ccc',
                          borderRadius: '8px',
                          padding: '1rem',
                          textAlign: 'center',
                          marginTop: '1rem',
                          cursor: 'pointer',
                          backgroundColor: isDragActive ? '#f0f8ff' : '#fff',
                        }}
                      >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <p>Drop the files here...</p>
                        ) : (
                          <p style={{ marginBottom: "0px" }}>Drag and drop files here, or click to select files <br /> <small><br /> Files Types allowed:  {fileTypes.join(', ')} </small></p>
                        )}
                      </div>

                      {/* Display Uploaded Files */}
                      <div style={{ marginTop: '1rem' }}>
                        <SubSectionTitle>Uploaded Files:</SubSectionTitle>
                        <Divider />
                        <Table>
                          <thead>
                            <tr>
                              <TableHeader>Name</TableHeader>
                              <TableHeader>Last Updated</TableHeader>
                              <TableHeader>Actions</TableHeader>
                            </tr>
                          </thead>
                          <tbody>
                            {uploadedFiles.map((doc, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  {/* Flex container forces the cross icon to the end of the cell */}
                                   <FileNameWrapper>
                                    <span>{doc.file_name}</span>
                                  </FileNameWrapper>
                                </TableCell>
                                <TableCell>{formatDate(doc.updated_at)}</TableCell>
                                <TableCell> 
                                  <DeleteButton
                                      onClick={() => handleDeleteKBFileInggestion(doc)}
                                      title="Delete file"
                                    >
                                      ✕ 
                                    </DeleteButton>
                                    </TableCell>
                              </TableRow>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    selectedDataSource.connectorDetails?.properties.map((ds, index) => (
                      <>
                        <FormGroup key={index}>
                          <Label>{formatString(ds)}</Label>
                          <Input
                            type="text"
                            value={selectedDataSource.data[ds] || ''}
                            onChange={(e) =>
                              setSelectedDataSource({
                                ...selectedDataSource,
                                data: {
                                  ...selectedDataSource.data,
                                  [ds]: e.target.value, // Update the specific property in the data object
                                },
                              })
                            }
                          />
                        </FormGroup>
                      </>
                    ))
                  )}

                  {/* Custom Properties */}
                  <div>
                    <SubSectionTitle>Custom Properties:</SubSectionTitle>
                    <Divider />
                    <Table>
                      <thead>
                        <tr>
                          <TableHeader>Key</TableHeader>
                          <TableHeader>Value</TableHeader>
                          <TableHeader>Actions</TableHeader>
                        </tr>
                      </thead>
                      <tbody>
                        {getNonConnectorProperties().map((key, index) => (
                          <TableRow key={index}>
                            <TableCell>{key}</TableCell>
                            <TableCell>{selectedDataSource.data[key]}</TableCell>
                            <TableCell>
                              <Button
                                onClick={() => removeCustomProperty(key)}
                                style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}
                              >
                                Remove
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </tbody>
                    </Table>
                    <Divider />
                    <FormRowFull style={{ display: 'flex', gap: '0.5rem' }}>
                      <Input
                        type="text"
                        value={newKey}
                        placeholder='Key'
                        onChange={(e) => setNewKey(e.target.value)}
                      />
                      <Input
                        placeholder='Value'
                        type="text"
                        value={newValue}
                        onChange={(e) => setNewValue(e.target.value)}
                      />
                      <Button primary style={{ marginTop: '0px' }}
                        onClick={() => {
                          if (newKey && newValue) {
                            addCustomProperty(newKey, newValue);
                            setNewKey('');
                            setNewValue('');
                          }
                        }}
                      >
                        Add
                      </Button>
                    </FormRowFull>
                  </div>
                  <FormRow>
                    <FormGroup>
                      <Label>Status</Label>
                      <Toggle>
                        <ToggleInput
                          type="checkbox"
                          checked={selectedDataSource.status === "ACTIVE"}
                          onChange={(e) => {
                            setSelectedDataSource({
                              ...selectedDataSource,
                              status: e.target.checked ? "ACTIVE" : "INACTIVE",
                            });
                          }}
                        />
                      </Toggle>
                    </FormGroup>
                  </FormRow>
                </div>
                <div style={{ display: 'flex',alignItems:'center', gap: '0.5rem', position: 'sticky', bottom: '0px', width: '100%', backgroundColor:"#f7f7ff", padding:'5px' }}>
            <Button
              onClick={() => saveDsChanges(selectedDataSource, selectedDataSourceIndex)}
            >
              Save
            </Button>
            <Button onClick={closeDrawer}>Cancel</Button>
          </div>
              </>
            )}
          </div>

          
        </div>
      )}

      {/* Custom Drawer */}
      {isEntityDrawerOpen && (
        <div className="custom-drawer entity-drawer">
          <div className="drawer-content">
            <SubSectionTitle>Entity Details</SubSectionTitle>
            <Divider />
            <Input type="text" placeholder="Search Attributes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <Table>
              <thead>
                <tr>
                  <TableHeader>Name </TableHeader>
                  <TableHeader>Type</TableHeader>
                </tr>
              </thead>
              <tbody>
                {filteredAttributes.map((attrib, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {attrib?.name}
                    </TableCell>
                    <TableCell>
                      {getAttribType(attrib?.type)}
                    </TableCell>
                  </TableRow>
                ))}
              </tbody>
            </Table>

            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button onClick={() => linkUnlinkEntity(selectedEntity)} >
                {checkIfPresent(selectedEntity.name) ? "Unlink" : "Link"}
              </Button>
              <Button onClick={closeEntityDrawer}>Cancel</Button>
            </div>
          </div>
        </div>
      )}
      {/* Modal */}
      {showModal && (
        <Modal
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeModal}
        >
          <ModalContent onClick={e => e.stopPropagation()}>
            <SubSectionTitle>Add New Data Source to Knowledge Base</SubSectionTitle>
            <Divider />
            <FormRow>
              <FormGroup>
                <Label>Data Source Name</Label>
                <Input type="text" value={selectedDataSource?.name || ''} onChange={(e) => setSelectedDataSource({ ...selectedDataSource, name: e.target.value })} />
              </FormGroup>
            </FormRow>
            {connector && (
              <>
                {connector.map((conn, index) => (
                  <Card key={index} style={{ width: '100%', padding: '1rem', marginTop: '1rem' }} >
                    <CardTitle>
                      <CommonHexagonBadge
                        stroke="stroke-brand-clarity"
                        fill="fill-brand-light"
                        size="size-[50px]"
                        iconImage={`/assets/images/connectors/${conn.code}.png`}
                        style={{ cursor: 'pointer' }}
                      />
                      <div style={{ cursor: 'pointer' }}>
                        <h5>Data Source: {conn.name}</h5>
                        <p>{conn.description}</p>
                      </div>
                      <div style={{ marginLeft: 'auto', marginRight: '50px', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={() => addDataSource(conn)}><FontAwesomeIcon icon={faPlus} /> Add</Button>
                      </div>
                    </CardTitle>
                  </Card>
                ))}
              </>
            )}

          </ModalContent>
        </Modal>
      )}


        <GenericModal size='xsm' 
                      isOpen={kbOverRideModalOpen} 
                      onClose={() => setKbOverRideModalOpen(false)} 
                      title="Similer files found"
                      cancelText='No'
                      confirmText='Yes'
                      onConfirm={() => {
                        setIsOverRideKb(true);
                        setKbOverRideModalOpen(false);
                      }}>
          <p>Same files found. Do you want to override ?</p>
        </GenericModal>

    </PageContainer>
  );
}

export default KnowledgebaseDetails_V2;